import echart, { EChartOption, EChartsResponsiveOption, ECharts } from 'echarts'
import { getTitleStringByType, getEveryDayDateStringList } from '@/utils/date'

export const drawSpendingAllChart = (chart: ECharts, data: any, filter: any) => {
  let xAxisData = getEveryDayDateStringList('2019-2-21', new Date())
  chart.setOption({
    title: {
      text: '全部消费数据'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['余额消费', '微信消费', '卡片消费']
    },
    xAxis: {
      data: xAxisData
    },
    yAxis: {},
    series: [
      {
        name: '余额消费',
        type: 'line',
        markLine: {
          data: [{ type: 'average', name: '平均值' }]
        },
        data: xAxisData.map((item:any) => {
          let listData = data.balance
          for (let total of listData) {
            let totalDate = new Date(total.date)
            let totalDateStr = `${totalDate.getFullYear()}-${totalDate.getMonth() + 1}-${totalDate.getDate()}`
            if (totalDateStr === item) {
              return parseFloat(parseFloat(total.total).toFixed(2))
            }
          }
          return 0
        })
      },
      {
        name: '微信消费',
        type: 'line',
        markLine: {
          data: [{ type: 'average', name: '平均值' }]
        },
        data: xAxisData.map((item:any) => {
          let listData = data.wepay
          for (let total of listData) {
            let totalDate = new Date(total.date)
            let totalDateStr = `${totalDate.getFullYear()}-${totalDate.getMonth() + 1}-${totalDate.getDate()}`
            if (totalDateStr === item) {
              return parseFloat(parseFloat(total.total).toFixed(2))
            }
          }
          return 0
        })
      },
      {
        name: '卡片消费',
        type: 'line',
        markLine: {
          data: [{ type: 'average', name: '平均值' }]
        },
        data: xAxisData.map((item:any) => {
          let listData = data.card
          for (let total of listData) {
            let totalDate = new Date(total.date)
            let totalDateStr = `${totalDate.getFullYear()}-${totalDate.getMonth() + 1}-${totalDate.getDate()}`
            if (totalDateStr === item) {
              return parseFloat(parseFloat(total.total).toFixed(2))
            }
          }
          return 0
        })
      }
    ]
  })
}
